const React = require("react");

module.exports = {
	// Leave a section empty for no known errors, ex. "1A": {}
	"1A": {
		combinedBookPracticeBook: [
			{
				page: 120,
				corrected: true,
				content: <span>problem 123 is missing the L in "split".</span>,
			},
		],
	},
	"1B": {},
	"1C": {
		combinedBookPracticeBook: [
			{
				page: 192,
				corrected: true,
				content: (
					<span>
						there is a missing 9 in the list of numbers in problem 84.
					</span>
				),
			},
		],
	},
	"1D": {
		combinedBookPracticeBook: [
			{
				page: 119,
				corrected: true,
				content: <span>problem 70 should say Tuesday instead of Monday.</span>,
			},
		],
	},
	"2A": {
		practice: [
			{
				page: 57,
				corrected: true,
				content: (
					<span>
						problem 83 should begin "The <b>eight</b> numbers below use only the
						digits 2 and 9."
					</span>
				),
			},
		],
		guide: [
			{
				page: 30,
				corrected: true,
				content: (
					<span>
						the section title should say "Re
						<b>g</b>
						rouping & Breaking."
					</span>
				),
			},
			{
				page: 38,
				corrected: true,
				content: (
					<span>
						in the second panel, Lizzie adds 62+70 and gets 135. Oops! This
						should be <b>132</b>.{" "}
					</span>
				),
			},
			{
				page: 55,
				corrected: true,
				content: (
					<span>
						the first line of the Play instructions should say, "Players take
						turns placing one of their own coins on the number line until the{" "}
						<b>number line</b> is full."
					</span>
				),
			},
		],
	},
	"2B": {
		practice: [
			{
				page: "50 and 52",
				corrected: true,
				content: (
					<span>
						the Guide Pages referenced at the bottom of the page should be{" "}
						<b>50-54</b>, not 44-49.
					</span>
				),
			},
		],
	},
	"2C": {
		practice: [
			{
				page: 76,
				corrected: true,
				content: (
					<span>
						we circled 19+12=31 where we should have circled 19+37=56.
					</span>
				),
			},
			{
				page: 147,
				corrected: true,
				content: (
					<span>
						the answer to problem 126 should conclude with, "We explore why this
						is impossible in problems 129-132."
					</span>
				),
			},
		],
		guide: [
			{
				page: 56,
				corrected: true,
				content: (
					<span>
						Winnie switches 77 and 78. She should say "Subtracting 78 is almost
						the opposite of adding 77."
					</span>
				),
			},
		],
	},
	"2D": {},
	"3A": {
		practice: [
			{
				page: 79,
				corrected: true,
				content: (
					<span>
						problem 57 should begin "<b>Three</b> regular hexagons..."
					</span>
				),
			},
			{
				page: 92,
				corrected: true,
				content: (
					<span>
						problem 111 should end with the word <b>polygons</b>, not
						rectangles.
					</span>
				),
			},
			{
				page: 114,
				corrected: true,
				content: (
					<span>
						in the solution to problem 90, Alex's skip-counting should end with{" "}
						<b>43</b>, not 41.
					</span>
				),
			},
		],
	},
	"3B": {
		practice: [
			{
				page: 120,
				corrected: true,
				content: (
					<span>
						the last sentence of the solution to problem 124 should begin "The
						area of a square..."
					</span>
				),
			},
			{
				page: 120,
				corrected: true,
				content: (
					<span>
						the solution to problem 130 assumes that 0 is not used. Since 0 is
						often considered a whole number, we can get 0+2+4+10=
						<b>16</b> if we use 0.
					</span>
				),
			},
			{
				page: 72,
				corrected: true,
				content: (
					<span>
						problem 130 is ambiguous (depending on whether or not zero is
						considered a whole number). If you consider 0 a whole number, the
						correct answer is 16 (0+2+4+10, for example).
					</span>
				),
			},
			{
				page: 86,
				corrected: true,
				content: (
					<span>
						problem 84 should ask "How many points did the <b>koombas</b>{" "}
						score?"
					</span>
				),
			},
			{
				page: 88,
				corrected: true,
				content: (
					<span>
						problem 91 has the dimensions of the third rectangle reversed. The
						height should be 700, and the width should be 270.
					</span>
				),
			},
		],
	},
	"3C": {
		practice: [
			{
				page: 58,
				corrected: true,
				content: (
					<span>
						it says "Use the following for Problems 101 and 102." It should say
						"...Problems 103 and 104."
					</span>
				),
			},
			{
				page: 61,
				corrected: true,
				content: (
					<span>
						in the example, the second explanation has two 11's that should be
						18's. It should say, "(10×
						<b>18</b>
						)÷7 has the same remainder as (3×4)÷7." The last sentence of the
						solution should read, "So, (10×
						<b>18</b>
						)÷7 has remainder 5."
					</span>
				),
			},
			{
				page: 66,
				corrected: true,
				content: (
					<span>
						there is a missing "that" in problem 149. The question should read,
						"What is the side length of an equilateral triangle <b>that</b> has
						the same perimeter as the nonagon?"
					</span>
				),
			},
			{
				page: 70,
				corrected: true,
				content: (
					<span>
						it should recommend that the book be used with Guide 3<b>C</b>, not
						3A.
					</span>
				),
			},
			{
				page: 92,
				corrected: true,
				content: (
					<span>
						our chart incorrectly lists September as having 31 days. September
						has 30 days.
					</span>
				),
			},
			{
				page: 102,
				corrected: true,
				content: (
					<span>
						the hint to problem 117 should replace the numbers 183, 184, and 185
						with 187, 188, and 189, respectively.
					</span>
				),
			},
			{
				page: 123,
				corrected: true,
				content: (
					<span>
						the solution to problem 104 should end with <b>117</b>
						÷9=13, not 17÷9=13.
					</span>
				),
			},
			{
				page: 124,
				corrected: true,
				content: (
					<span>
						the solution to problem 117 should read (187+188+189)÷75, not
						(183+184+186)÷75.
					</span>
				),
			},
			{
				page: 129,
				corrected: true,
				content: (
					<span>
						the solution to problem 146 says that 72÷6 has remainder 6. It
						should say that 72÷6 has remainder <b>0</b>.
					</span>
				),
			},
			{
				page: 128,
				corrected: true,
				content: (
					<span>
						the solution to problem 144 should say, "We find the remainder when
						each number is divided by <b>5</b>
						".
					</span>
				),
			},
		],
		guide: [
			{
				page: 20,
				corrected: true,
				content: (
					<span>
						the second panel lists 4 equations. The second equation is listed as
						10+n=3, but should have been 10-n=3.
					</span>
				),
			},
			{
				page: 20,
				corrected: true,
				content: (
					<span>
						the fourth equation should have been 11+n=
						<b>14</b> to match the equation Grogg solves on the next page.
					</span>
				),
			},
		],
	},
	"3D": {
		practice: [
			{
				page: 40,
				corrected: true,
				content: (
					<span>
						we misspelled <b>denominators</b> as denominatators in the first
						balloon. Oops!
					</span>
				),
			},
			{
				page: 54,
				corrected: true,
				content: (
					<span>
						problem 58 should be 866+1,671=2,5
						<b>3</b>
						7.
					</span>
				),
			},
			{
				page: 60,
				corrected: true,
				content: (
					<span>
						problem 88 incorrectly states that 1600-1000=
						<b>700</b>
						!? Of course, we meant to say 1600-1000=
						<b>600</b>.
					</span>
				),
			},
			{
				page: 64,
				corrected: true,
				content: (
					<span>
						the worked example should state, "Since 268 is greater than 250 and{" "}
						<b>765</b> is greater than 750..." (765 replaces 768).
					</span>
				),
			},
			{
				page: 106,
				corrected: true,
				content: (
					<span>
						the hint for problem 148 is from a discarded problem about teeth
						brushing.
					</span>
				),
			},
			{
				page: 132,
				corrected: true,
				content: (
					<span>
						in the solution to problem 32, the last sentence should say that we
						round 23 5/
						<b>9</b> up to 24.
					</span>
				),
			},
			{
				page: 138,
				corrected: true,
				content: (
					<span>
						the solution to problem 101 should read, "333 is close to <b>320</b>
						..."
					</span>
				),
			},
			{
				page: 138,
				corrected: true,
				content: (
					<span>
						{" "}
						in the solution to problem 104, both 6,273's should be 6,2
						<b>37</b>
						's.
					</span>
				),
			},
			{
				page: 147,
				corrected: true,
				content: (
					<span>
						the solution to problem 27 incorrectly lists the units as 128 sq in.
						The units should be <b>sq cm</b>.
					</span>
				),
			},
		],
		guide: [
			{
				page: 48,
				corrected: true,
				content: (
					<span>
						in panel 4, Winnie should have said, "We can write 15/16 and{" "}
						<b>29</b>
						/32 with the same denominator!"
					</span>
				),
			},
			{
				page: 69,
				corrected: true,
				content: (
					<span>
						the first balloon says "...40,000 360,000, coins." It should just
						say "...40,000 coins."
					</span>
				),
			},
			{
				page: 70,
				corrected: true,
				content: (
					<span>
						Winnie should have said "...it's helpful to use two numbers..." (not
						"to" numbers).
					</span>
				),
			},
			{
				page: 88,
				corrected: true,
				content: (
					<span>Captain Kraken's speech balloon is the wrong color.</span>
				),
			},
		],
	},
	"4A": {
		practice: [
			{
				page: 29,
				corrected: true,
				content: (
					<span>
						Symmetry Defense is much more interesting if the 'Moving' round
						begins with Player 2. As written in the first printing, Player 1
						should be able to win every game.
					</span>
				),
			},
			{
				page: 81,
				corrected: true,
				content: (
					<span>
						the example instructions should say, "...as the square of a number,"
						not "...as a the square of a number."
					</span>
				),
			},
			{
				page: 88,
				corrected: true,
				content: (
					<span>
						in the 8th paragraph, the last sentence should read 13^5 × 13 = 13^
						<b>6</b> ends in 9.
					</span>
				),
			},
			{
				page: 103,
				corrected: true,
				content: (
					<span>
						the hint given to problem 60 should say "Angle <b>PQR</b>
						?" not PRQ.
					</span>
				),
			},
			{
				page: 104,
				corrected: true,
				content: (
					<span>
						the hint given to problem 139 should say "<b>...yzzz</b> is between
						4,000 and 6,000."
					</span>
				),
			},
			{
				page: 107,
				corrected: true,
				content: (
					<span>
						the solution to problem 7 should state that "Only the <b>third</b>{" "}
						diagram shows one point."
					</span>
				),
			},
			{
				page: 128,
				corrected: true,
				content: (
					<span>
						the answer given to problem 22 should be 123
						<b>2</b>, not 1234.
					</span>
				),
			},
			{
				page: 136,
				corrected: true,
				content: (
					<span>
						in the solution to problem 81, the answer given to 68×75 should be{" "}
						<b>5,100</b>, not 5,000.
					</span>
				),
			},
			{
				page: 146,
				corrected: true,
				content: (
					<span>
						the solution given to problem 139 should say "<b>...yzzz</b> is
						between 4,000 and 6,000."
					</span>
				),
			},
			{
				page: 152,
				corrected: true,
				content: (
					<span>
						in the solution to problem 23, it should say that "<b>...3^2</b> is
						the product of two 3's..."
					</span>
				),
			},
			{
				page: 154,
				corrected: true,
				content: (
					<span>
						in the solution to Problem 51 the parentheses are wrong in the
						next-to-last paragraph. (3×4×5)+2 should be <b>3×(4×5+2)</b>.
					</span>
				),
			},
			{
				page: 158,
				corrected: true,
				content: (
					<span>
						the solution to problem 88 should read "Then, since <b>4=2×2</b>
						," not "4=3×2."
					</span>
				),
			},
			{
				page: 160,
				corrected: true,
				content: (
					<span>
						problem 108 should say that 26^3=(2×13)^
						<b>3</b>.
					</span>
				),
			},
			{
				page: 166,
				corrected: true,
				content: (
					<span>
						in problems 144 and 145, the final list of answers includes 1,000
						instead of <b>10,000</b>.
					</span>
				),
			},
		],
		guide: [
			{
				page: 11,
				corrected: true,
				content: (
					<span>
						the Headmaster should have said that some of the topics go well
						beyond what is typically taught in a <b>fourth</b> grade math class.
					</span>
				),
			},
			{
				page: 29,
				corrected: true,
				content: (
					<span>
						the stop sign should have a question mark instead of a period.
					</span>
				),
			},
			{
				page: 30,
				corrected: true,
				content: (
					<span>
						Ms. Q. should have asked, "Now, who wants to make a kite?"
					</span>
				),
			},
			{
				page: "35-36",
				corrected: true,
				content: (
					<span>
						the very center of the compass rose should be all one color. As-is,
						the compass rose has rotational symmetry of order 2.
					</span>
				),
			},
			{
				page: 77,
				corrected: true,
				content: (
					<span>evaluate is misspelled in Lizzie's writing in panel 1.</span>
				),
			},
			{
				page: 79,
				corrected: true,
				content: (
					<span>
						the first rule lists 6^2+5^2+1^2=52. However, 6^2+5^2+1^2=
						<b>62</b>.
					</span>
				),
			},
		],
	},
	"4B": {
		practice: [
			{
				page: 10,
				corrected: true,
				content: (
					<span>
						the solution to the example says "We can place 24÷4=5 more posts..."
						It should read, "We can place <b>20</b>
						÷4=5 more posts..."
					</span>
				),
			},
			{
				page: 18,
				corrected: true,
				content: (
					<span>
						problem 41 should read, "...flips a coin six times and records the
						results."
					</span>
				),
			},
			{
				page: 22,
				corrected: true,
				content: (
					<span>
						the example should read, "...a survey of <b>19</b> pet owners."
					</span>
				),
			},
			{
				page: 24,
				corrected: true,
				content: (
					<span>
						we omitted a word. Grogg's mom should have counted "...11 monsters
						that <b>have</b> no wings and no tail."
					</span>
				),
			},
			{
				page: 92,
				corrected: true,
				content: (
					<span>
						in the first step of the example explanation, it should read, "We
						draw a triangle to represent the <b>tent</b>
						,..."
					</span>
				),
			},
			{
				page: 104,
				corrected: false,
				content: (
					<span>
						the solution to problem 23 is missing a <b>+6</b> in the equation.
					</span>
				),
			},
			{
				page: 108,
				corrected: true,
				content: (
					<span>
						in the solution to problem 57 below the first diagram it should
						read, "...we first subtract <b>8</b> from each number..."
					</span>
				),
			},
			{
				page: 126,
				corrected: true,
				content: (
					<span>
						the solution to problem 144 has a 1,625 in the final paragraph that
						should be <b>1,624</b>.
					</span>
				),
			},
		],
		guide: [
			{
				page: "20",
				corrected: false,
				content: (
					<span>"hamburger" is misspelled in Alex's speech balloon.</span>
				),
			},
			{
				page: "23-24",
				corrected: true,
				content: (
					<span>
						the words ketchup and mustard are switched in multiple panels.
					</span>
				),
			},
			{
				page: 24,
				corrected: true,
				content: (
					<span>
						in the last blue speech balloon, the words ketchup and mustard are
						switched.
					</span>
				),
			},
			{
				page: 39,
				corrected: true,
				content: (
					<span>
						Winnie lists the pair of Winnie and Lizzie as "A&L." It should say
						"W&L."
					</span>
				),
			},
			{
				page: 49,
				corrected: true,
				content: (
					<span>
						the stop sign should read, "Is there a number you can multiply by 0
						to get 6?" (the 0 and 6 are switched).
					</span>
				),
			},
			{
				page: 53,
				corrected: true,
				content: (
					<span>
						in Ms. Q.'s first speech balloon, there is a 0 missing. It should
						read, 3,500,00
						<b>0</b>.
					</span>
				),
			},
		],
	},
	"4C": {
		practice: [
			{
				page: "50 and 51",
				corrected: true,
				content: (
					<span>
						problems 80 and 82 both say, "One the line below,..." Both should
						read "<b>On</b> the line below,...".
					</span>
				),
			},
			{
				page: 60,
				corrected: true,
				content: (
					<span>
						problem 134 should have read 7-9/10 minus 2-
						<b>3</b>
						/10 to match the solution given.
					</span>
				),
			},
			{
				page: 65,
				corrected: true,
				content: (
					<span>
						problem 167 has an extra <b>of</b> in the question "How many of
						ounces of...".
					</span>
				),
			},
			{
				page: 144,
				corrected: true,
				content: (
					<span>
						the answer to problem 182 should read 16 <b>meters</b>.
					</span>
				),
			},
		],
		guide: [
			{
				page: 18,
				corrected: true,
				content: (
					<span>
						in the bottom panel, Alex should have said 71 instead of 73.
					</span>
				),
			},
			{
				page: 25,
				corrected: true,
				content: (
					<span>
						there is a square in the first chart that should be green. Can you
						find it?
					</span>
				),
			},
			{
				page: 88,
				corrected: true,
				content: (
					<span>
						in the last panel, Winnie's speech balloon is the wrong color.
					</span>
				),
			},
		],
	},
	"4D": {
		practice: [
			{
				page: 19,
				corrected: true,
				content: (
					<span>the entry blank for problem 76 should not include n=.</span>
				),
			},
			{
				page: 70,
				corrected: true,
				content: (
					<span>
						problem 200 should have 2.97, not 1.98 in the problem statement. The
						problem is impossible as written.
					</span>
				),
			},
			{
				page: 98,
				corrected: true,
				content: (
					<span>
						problem 105 should have read, "What is the probability that both
						jellybeans are <b>green</b>
						?"
					</span>
				),
			},
			{
				page: 134,
				corrected: true,
				content: (
					<span>
						the solution to problem 200 should have 2.97, not 1.97, in every
						instance.
					</span>
				),
			},
		],
		guide: [
			{
				page: "49, 60, and 68",
				corrected: true,
				content: (
					<span>
						the red boxes giving Practice page recommendations (39-49, 50-61,
						and 62-71, respectively) are missing.
					</span>
				),
			},
			{
				page: 111,
				corrected: true,
				content: (
					<span>
						in the index entry under number line, the word multiplying is
						misspelled.
					</span>
				),
			},
		],
	},
	"5A": {
		practice: [
			{
				page: 34,
				corrected: true,
				content: (
					<span>
						problem 134 should say, "The area of the base of the{" "}
						<b>decagonal</b> prism..." The prism's base is a decagon, not a
						dodecagon.
					</span>
				),
			},
			{
				page: 36,
				corrected: true,
				content: (
					<span>
						problem 150 should say, "Both faces of the 4×5 <b>block</b> were
						painted red." The block is not a cube.
					</span>
				),
			},
			{
				page: 100,
				corrected: true,
				content: (
					<span>problem 176 should end in a question mark, not a period.</span>
				),
			},
			{
				page: 105,
				corrected: true,
				content: (
					<span>
						the Chapter 3 heading should be Expressions & Equations (not
						Integers).
					</span>
				),
			},
			{
				page: 108,
				corrected: true,
				content: (
					<span>
						the bolded answer to problem 24 should say "hexagonal pyramid", not
						"hexagonal prism."
					</span>
				),
			},
		],
	},
	"5B": {
		practice: [
			{
				page: 29,
				corrected: true,
				content: (
					<span>problem 112 should have an l in the word "monthy."</span>
				),
			},
			{
				page: 64,
				corrected: true,
				content: (
					<span>
						it should say, "Use this Practice book with Guide 5B..." (not 4C).
					</span>
				),
			},
			{
				page: 74,
				corrected: true,
				content: (
					<span>
						the example is broken. In the top four diagrams, the sum of the
						bottom row is 1/4, which makes the puzzle impossible. In the bottom
						two diagrams, the sum of this row is 3/4, which creates several
						possible solutions.
					</span>
				),
			},
			{
				page: 76,
				corrected: true,
				content: (
					<span>
						the example solution should state that 2/1 is <b>greater</b> than 1.
					</span>
				),
			},
			{
				page: 120,
				corrected: true,
				content: (
					<span>
						the solution to problem 16 should include 11 in the list of smallest
						factors of 2,772.
					</span>
				),
			},
			{
				page: 146,
				corrected: true,
				content: (
					<span>
						in the solution to problem 85, the fraction 6/15 should be 6/
						<b>45</b>.
					</span>
				),
			},
		],
		guide: [
			{
				page: 52,
				corrected: true,
				content: (
					<span>
						the stop sign at the bottom of the page should ask for the GCF of
						2,772 and 3,5
						<b>6</b>4 (not 3,584).
					</span>
				),
			},
			{
				page: 62,
				corrected: false,
				content: (
					<span>
						in the first panel, Winnie multiplies an extra 3 in her speech
						balloon.
					</span>
				),
			},
			{
				page: 66,
				corrected: true,
				content: (
					<span>
						the common primes in the overlapping section of Grogg's Venn diagram
						are 2, 2, and 3. He inexplicably multiplies 2×3×3=18 to get the GCF
						of 84 and 108. He should have multiplied <b>2×2×3=12</b>.
					</span>
				),
			},
			{
				page: 81,
				corrected: true,
				content: (
					<span>
						the stop sign should ask for the smallest denominator of <b>7</b>
						/10 + <b>2</b>
						/15.
					</span>
				),
			},
			{
				page: 98,
				corrected: true,
				content: (
					<span>
						Grogg's last balloon should read 23/20÷
						<b>22/15</b>, not 23/20÷15/22.
					</span>
				),
			},
			{
				page: 107,
				corrected: true,
				content: (
					<span>
						Alex should not have included 11 and 25 as a pair of primes (since
						25 is not prime). Even the brightest little monsters at Beast
						Academy make mistakes sometimes.
					</span>
				),
			},
		],
	},
	"5C": {
		practice: [
			{
				page: 19,
				corrected: true,
				content: (
					<span>
						problem 86 should ask for the common difference of an <b>eight</b>
						-term sequence.
					</span>
				),
			},
			{
				page: 42,
				corrected: true,
				content: (
					<span>
						the second paragraph of the first Example solution has the words
						juice and soda switched.
					</span>
				),
			},
			{
				page: 61,
				corrected: false,
				content: <span>problem 127 includes the word "can" twice.</span>,
			},
			{
				page: 103,
				corrected: true,
				content: (
					<span>
						problem 200, the 83/11 clue should be replaced with <b>31/9</b>. The
						solution will reflect this change.
					</span>
				),
			},
			{
				page: 122,
				corrected: true,
				content: (
					<span>
						the solution to problem 76 should include the sequence 45-
						<b>49</b>
						-53-57-61.
					</span>
				),
			},
			{
				page: 134,
				corrected: true,
				content: (
					<span>
						the solution to problem 150a should be 32, 24, <b>43</b>, 35, 54,
						46, 65, 57, 76, 68.
					</span>
				),
			},
			{
				page: 135,
				corrected: false,
				content: (
					<span>
						the solution to problem 153 has only 9 terms, while the actual
						problem provides space for ten terms.
					</span>
				),
			},
			{
				page: 147,
				corrected: false,
				content: (
					<span>
						the solution to problem 79 should say 5x = 5⋅<b>16</b> = 80.
					</span>
				),
			},
		],
		guide: [
			{
				page: 58,
				corrected: true,
				content: <span>Grogg's question should end in a question mark.</span>,
			},
		],
	},
	"5D": {
		practice: [
			{
				page: 30,
				corrected: true,
				content: (
					<span>
						problem 150 should ask, "How many <b>kilometers</b> did Anna run?"
					</span>
				),
			},
		],
	},
	puzzles2: {
		// puzzle: [
		// 	{
		// 		page:
		// 		corrected:
		// 		content:
		// 	}
		// ],
	},
	noError: `There are no known errors for this book.`,
};
